import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';

import { SnackbarProvider } from 'notistack';

import { ThemeProvider, CssBaseline, Slide } from '@material-ui/core';

import App from './App';

import { store } from 'redux/store';

import { theme } from 'styles/theme';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, { response: { data } }) => {
        return data.code === 401 && data.message === 'jwt expired';
      },
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <BrowserRouter>
          <SnackbarProvider
            preventDuplicate
            maxSnack={4}
            TransitionComponent={Slide}
          >
            <App />
            <CssBaseline />
          </SnackbarProvider>
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  </QueryClientProvider>,
  document.getElementById('root'),
);
